import React, { useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { ThemeProvider, CssBaseline, Container, Box } from "@mui/material";
import theme from "./theme";
import AbstractBackground from "./components/AbstractBackground";
import HeroCard from "./components/HeroCard";

const useStyles = makeStyles(() => ({
  container: {
    height: "calc(var(--vh, 1vh) * 100)", // Use the CSS variable for dynamic viewport height
    display: "flex",
    flexDirection: "column",
    overflowY: "auto", // Allow vertical scrolling
    WebkitOverflowScrolling: "touch", // Enable momentum scrolling on iOS
    minHeight: "600px",
  },
  contentArea: {
    flexGrow: 1,
    overflow: "hidden",
    display: "flex",
    margin: 16,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.15)",
    flexDirection: "column",
    background: `linear-gradient(to top, 
    rgba(255, 255, 255, 0.8),  /* Dark Violet at 80% opacity */
    rgba(0, 116, 211, 0.1)  /* 20% transparent fade */
  )`,
  },
}));
const App = () => {
  const loading = useSelector((state) => state.loading);
  const classes = useStyles();
  const containerRef = useRef(null);

  const memoizedBackground = useMemo(() => <AbstractBackground animate={loading} containerRef={containerRef} />, [loading]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="lg" className={classes.container} ref={containerRef}>
        {memoizedBackground}
        <Box className={classes.contentArea}>
          <HeroCard />
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default App;